import $ from 'jquery';
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import { Step, StepLabel, Stepper } from 'material-ui/Stepper';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-touch-screen-keyboard/lib/Keyboard.css';
import * as actions from '../../actions/actions.jsx';
import answerimg from '../../images/answer.png';
import creditcardlogo from '../../images/credit-cards-vector-icon-.jpg';
import services from '../../services/allservices.jsx';
import '../../stylesheet/activate.css';
import '../../stylesheet/resetquestion.css';
import '../../stylesheet/virtualkeyboard.css';
import LoaderSmall from "../loader/loadersmall.jsx";
import GusetNavbar from '../navigation/guestnavbar.jsx';
import DefaulNavbar from '../navigation/defaultnavbar.jsx';
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth';
import uuidv4 from 'uuid/v4';
import OtpPopup from '../otp/OtpPopup.js';
/**
 * Vertical steppers are designed for narrow screen sizes. They are ideal for mobile.
 *
 * To use the vertical stepper with the contained content as seen in spec examples,
 * you must use the `<StepContent>` component inside the `<Step>`.
 *
 * <small>(The vertical stepper can also be used without `<StepContent>` to display a basic stepper.)</small>
 */


const styles = {
    stepbutton: {
        fill: "rgb(48, 86, 151)"
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    floatingLabelStyle: {
        fontSize: "18px",
        color: "#333"
    },
    floatingLabelStyle1: {
        fontSize: "15px",
        color: "#333"
    },
    underlineStyle: {
        borderBottom: '1px solid #333',
    }
}

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardNumber: state.stoteCardDetail.cardNumber,
    secretQues: state.secretQuesReducer.secretQues,
    quesReceived: state.secretQuesReducer.quesReceived,
    validUserIdState: state.getValidIdReducer.validUserIdState,
    activationcardState: state.getactivationcardReducer.activationcardState
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchSecretQues(quesReceived) {
        dispatch(
            actions.secretQuesAction(quesReceived)
        )
    },
    validateUserId(username) {

        dispatch(
            actions.validateUserIdAction(username)
        )
    },
    getactivation(state) {

        dispatch(
            actions.getactivationcardAction(state)

        )
    },
})


const JSEncrypt = window.JSEncrypt
class ResetQuestion extends React.Component {

    constructor(props) {
        super(props);
        this.handleActivate = this.handleActivate.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleUserInfo = this.handleUserInfo.bind(this)
        this.handleVerify = this.handleVerify.bind(this)
        this.findDescription = this.findDescription.bind(this)
        this.handleActiveUser = this.handleActiveUser.bind(this)
        this.validusernameresp = this.validusernameresp.bind(this)
        this.otpPopupOpenModal = this.otpPopupOpenModal.bind(this);
        this.otpPopupCloseModal = this.otpPopupCloseModal.bind(this);
    }

    state = {
        otpOpen: false,
        otp: "",
        popupLoader: false,
        response: "",
        activatedCardNumber: "",
        activatedFirstName: "",
        activatedLastName: "",
        activatedExpDate: "",
        stepIndex: 0,
        pin: "",
        confirmPin: "",
        correctUsername: true,
        correctPassword: true,
        customMapping: [
        ],
        expiry: new Date().getDate() + "/" + (new Date().getMonth() + 1),
        confirmPinError: false,

        pinError: false,
        expiryError: false,
        openWrongPinSnac: false,
        value: "", secretPassword: "", userName: "", password: "", email: "", confirmPassword: "",
        usernameVerified: false,
        actualCardNumber: "",
        actualExpiryNumber: "",
        actualMobileNumber: "",
        cardNumber: "",
        expiryNumber: "",
        cardVerified: false,
        rederFeedback: false,
        verification: true,

        expiryVerified: false,
        rederFeedback1: false,
        expiryVerification: true,
        exipryField: true,

        disabled: true,

        mobilecardVerified: false,
        mobilerederFeedback: false,
        mobileNumberVerified: false,
        mobileverification: true,

        dobVerified: false,
        dobRederFeedback: false,
        dobverification: true,
        disabledUserInfo: true,

        DobDisabled: true,
        secAnsDisabled: true,
        secAnsSubmit: true,
        correctDob: true


        // value: 1
    };

    handleCapcha(value) {
        this.setState({
            capcha: value
        })
    }
    handleSelect = (event, index, value) => {
        let _this = this
        this.findDescription(value)
        this.setState({
            value
        }, () => {
            _this.setState({
                secAnsDisabled: false,
                correctDob: true
            })
        })
    };
    findDescription(value) {
        const { secretQues } = this.props
        for (let i = 0; i < secretQues.body.length; i++) {
            if (secretQues.body[i].secretQuestionCode === value) {
                this.setState({ description: secretQues.body[i].description })
            }
        }
    }
    componentDidMount() {

        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") === "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });

        this.props.fetchPublicKey(false)
        this.props.fetchSecretQues(false)


    }
    removepwd = () => {
        this.setState({
            correctpawd: true
        })
    }
    removeemail = () => {
        this.setState({
            correctEmail: true
        })
    }
    onChange(e, ansValue) {
        let _this = this
        if (this.state.value !== "DOB") {

            this.setState({
                [e.target.name]: ansValue,
                correctDob: true
            }, () => {
                if (_this.state.secretAnswer.length > 0) {
                    _this.setState({
                        secAnsSubmit: false,
                        correctDob: true,
                        secretPassword: ansValue
                    })

                }
                else {
                    _this.setState({
                        secAnsSubmit: true,
                        correctDob: true
                    })
                }
            })
        }

    }
    handleValueChange(val) {
        if (val.length <= 4) {
            this.setState({ pin: val });
        }
    }
    handleValueChangeconfirm(val) {
        if (val.length <= 4) {
            this.setState({ confirmPin: val });
        }
    }
    handleValueChangenext(val) {
        if (val.length <= 4) {
            this.setState({ pin: val });
        }
    }
    handleValueChangeconfirmnext(val) {
        if (val.length <= 4) {
            this.setState({ confirmPin: val });
        }
    }




    validusernameresp = () => {
        //    const {validUserIdState} = this.props

        let validstate1 = localStorage.getItem("validUserId")





        let validState = JSON.parse(validstate1)
        if (validState.body.userIdAvailable === false) {
            this.setState({
                usernameVerified: false
            }, () => {
                document.getElementById("valid1").style.display = "none"
                document.getElementById("invalid1").style.display = "block"
                document.getElementById("myModal").style.display = "block"


            })
        }
        else {
            this.setState({
                usernameVerified: false
            }, () => {
                document.getElementById("invalid1").style.display = "none"
                document.getElementById("valid1").style.display = "block"


            })
        }

    }
    handleClose = () => {
        if (document.getElementById("username") !== null) {

            document.getElementById("username").value = ""
            document.getElementById("username").focus()
        }
        document.getElementById("invalid1").style.display = "none"
        document.getElementById("myModal").style.display = "none"


    }

    checkUserName = (e, value) => {
        let _this = this
        if (e.target.name === "userName") {
            if ((e.target.value.length) >= 6) {
                this.props.validateUserId(_this.state.userName)
                this.setState({
                    usernameVerified: true,
                    userName: value || _this.state.userName
                })

                setTimeout(function () {
                    _this.validusernameresp()
                }, 1000)

            }

            else {
                this.setState({
                    correctUsername: false
                })
            }
        }


    }
    handleExpiry(e) {
        let _this = this
        const { name } = e.target
        this.setState({ [name]: e.target.value })



        let string = e.target.value;
        const expiryNumber = string.replace(/\//g, "");
        const actualExpiryNumber = expiryNumber.replace(/_/g, "");

        const { publicKey } = this.props

        if (actualExpiryNumber.length >= 4) {
            //  now validation will be via verify card api below code not needed for prod or test

            // if (!actualExpiryNumber.startsWith('48138122')) {
            //     toast.error(('Invalid Card Number'), {
            //         position: "top-right",
            //         draggablePercent: 60,
            //         autoClose: 3000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: false
            //     });
            //     return;
            // }

            this.setState({
                expiryVerified: true,
                rederFeedback1: false,
                actualExpiryNumber: actualExpiryNumber,
                title: "Please enter valid expiry number",
                // disabled:false

            })




            if (publicKey && publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let encrypted = encrypt.encrypt(expiryNumber);
                // this.props.storeCardNumber(encrypted)
                localStorage.setItem("expiryNumber", encrypted)
                this.setState({ expiryNumber: encrypted })
                const state = {
                    expiryDate: encrypted,
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    cardNumber: this.state.cardNumber
                }
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let gid = getClientId();
                let traceId = getClientId();
                fetch(plink + services.resetsq_expiry_verify, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': gid,
                        //  'clientSecret': getClientSecret(gid,accountId),
                        'clientSecret': getClientSecret(gid, this.state.actualCardNumber),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader(),

                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {

                            response.json().then(function (object) {

                                _this.setState({
                                    expiryVerified: false,
                                    rederFeedback1: true,
                                    expiryVerification: true,
                                }, () => {
                                    if (object.cardExpiryVerified === true && object.cardVerified === false) {
                                        _this.setState({
                                            disabled: false
                                        })

                                    }

                                    else {
                                        _this.setState({
                                            disabled: true
                                        })
                                    }
                                })


                            })




                        } else {
                            _this.setState({
                                expiryVerified: false,
                                rederFeedback1: true,
                                expiryVerification: false,
                                disabled: true

                                // mobiledisable: true,
                                // title: "Please enter valid card number"
                            })
                            // eslint-disable-next-line
                            toast.error(response.headers.get('message')), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            };

                        }
                    })
            }
        }
        else {
            if (actualExpiryNumber.length !== 0) {
                this.setState({
                    disabled: true
                })
                // eslint-disable-next-line
                toast.error(('please enter valid expiry number'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    // disabled:true
                });
            }
        }
    }

    handleMobileNumber(e) {
        let _this = this
        let mobNum = e.target.value;

        // const actualMobileNumber = mobNum.replace(/_/g, "");

        const { publicKey } = this.props

        if (mobNum.length >= 3) {

            this.setState({
                mobilecardVerified: true,
                mobilerederFeedback: false,
                mobileNumberVerified: true,
                mobNum: mobNum,
                title: "Please enter valid mobile number",
                // disabledUserInfo:false,
            })


            if (publicKey && publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);

                let encrypted = encrypt.encrypt(mobNum);
                // this.props.storeCardNumber(encrypted)
                localStorage.setItem("mobileNumber", encrypted)
                this.setState({ mobileNumber: encrypted })
                const state = {
                    mobileNumber: encrypted,
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    cardNumber: this.state.cardNumber
                }
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let traceId = getClientId();
                let gmid = getClientId();
                fetch(plink + services.resetsq_mobNum_verify, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': gmid,
                        'clientSecret': getClientSecret(gmid, mobNum),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader(),
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {

                            response.json().then(function (object) {

                                if (object.mobileNumberVerified === true) {
                                    _this.setState({
                                        mobilecardVerified: false,
                                        mobileNumberVerified: false,
                                        mobilerederFeedback: true,
                                        mobileverification: true,
                                        DobDisabled: false,
                                        // disabledUserInfo:false,

                                    })
                                    if (object.mobileNumberVerified === true) {
                                        _this.setState({
                                            dobVerified: false,

                                        }, () => {
                                            document.getElementById('dateofbirth').focus()
                                        })
                                    }

                                }

                            })

                        } else {
                            _this.setState({
                                mobilecardVerified: false,
                                mobilerederFeedback: true,
                                mobileNumberVerified: true,
                                mobileverification: false,
                                disabledUserInfo: true,
                                // mobiledisable: true,
                                // title: "Please enter valid card number"
                            })
                            // eslint-disable-next-line
                            toast.error(response.headers.get('message')), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,


                            };

                        }
                    })
            }
        }
        else {
            if (mobNum.length !== 0) {

                this.setState({
                    disabledUserInfo: true,
                })
                // eslint-disable-next-line
                toast.error(('Invalid Mobile Number'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    disabledUserInfo: true,
                });
            }

        }

    }

    checkCardNumber(e) {
        const { name } = e.target
        this.setState({ [name]: e.target.value })



        let _this = this
        let string = e.target.value;
        const cardNumber = string.replace(/-/g, "");
        const actualCardNumber = cardNumber.replace(/_/g, "");


        const { publicKey } = this.props
        if (actualCardNumber.length === 16) {


            this.setState({ cardVerified: true, rederFeedback: false, actualCardNumber: actualCardNumber, mobiledisable: true, title: "Invalid Card Number" })

            if (publicKey && publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let encrypted = encrypt.encrypt(cardNumber);
                // this.props.storeCardNumber(encrypted)
                localStorage.setItem("cardNumber", encrypted)
                this.setState({ cardNumber: encrypted })
                const state = {
                    cardNumber: encrypted,
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
                }
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let grid = getClientId();
                let traceId = getClientId();
                fetch(plink + services.resetsq_card_verify, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': grid,
                        'clientSecret': getClientSecret(grid, actualCardNumber),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader(),

                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {

                            response.json().then(function (object) {
                                localStorage.setItem("otpValidation", object.otpValidation)

                                _this.setState({
                                    cardVerified: false,
                                    rederFeedback: true,
                                    verification: true,
                                    title: '',
                                    cardVerificationDone: true,
                                    cardAccountId: object.accountId,
                                    otpValidation: object.otpValidation
                                })

                                localStorage.setItem("cardAccountId", object.accountId)
                                if (object.cardVerified === true) {
                                    _this.setState({
                                        exipryField: false,

                                    }, () => {
                                        document.getElementById('expiry').focus()
                                    })
                                }

                            })

                        } else {
                            _this.setState({
                                cardVerified: false,
                                rederFeedback: true,
                                verification: false,
                                mobiledisable: true,
                                title: "Invalid Card Number",
                                disabled: true,
                            })
                            // eslint-disable-next-line
                            toast.error(response.headers.get('message')), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            };

                        }
                    })
            }
        }
        else {
            if (actualCardNumber.length !== 0 && actualCardNumber.length <= 15)
                // eslint-disable-next-line
                toast.error(('Invalid Card Number'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
        }

    }


    handlediable = () => {

        // if (this.state.verification === true && this.state.expiry.length !== 0) {
        //     this.setState({
        //         disabled: false

        //     })
        // }
        // else {
        //     this.setState({
        //         disabled: true
        //     })
        // }


    }
    handleGoback = (e) => {
        // localStorage.clear();
        // this.props.history.push("/login")
        const pform = localStorage.getItem("pform");

        localStorage.clear();

        if (pform) {
            localStorage.setItem("pform", pform);
        }

        this.props.history.push("/login");
    }



    otpPopupOpenModal() {
        if (this.state.otpValidation === false || this.state.otpValidation === 'false') {
            // Skip OTP — call final API directly
            this.setState({ otp: "", popupLoader: true }, () => {
                this.handleSubmitQA(null, null);
            });
            return;
        }

        this.setState({
            otpOpen: true,
        }, () => {
            this.handleRequestOtp(false);
        });
    }

    // for otp close
    otpPopupCloseModal() {

        this.setState({
            otpOpen: false,
            popupLoader: false,
        });
    }
    handleRequestOtp = (isResend = false) => {

        const { publicKey } = this.props;

        const cardAccountId = this.state.cardAccountId || localStorage.getItem('cardAccountId')

        const plainCardNumber = this.state.actualCardNumber;

        if (publicKey && publicKey.status === 200) {

            const public_Key = publicKey.body.publickey;

            let encrypt = new JSEncrypt();

            encrypt.setPublicKey(public_Key);

            let encryptedCardNumber = encrypt.encrypt(plainCardNumber);

            let traceId = getClientId();

            let gid = getClientId();

            const payload = {

                accountId: cardAccountId,

                applicationId:
                    localStorage.getItem("pform") === "AU"
                        ? "klickexau"
                        : "klickex"

            };
            if (isResend) {
                payload.reSendOtp = true;
            }


            this.setState({
                loader: true
            });

            let plink =
                localStorage.getItem('pform') === 'AU'
                    ? process.env.REACT_APP_SERVICEURL_AU
                    : process.env.REACT_APP_SERVICEURL_NZ;

            fetch(plink + services.otp_reset_qa, {

                method: "POST",

                headers: new Headers({

                    "Content-Type": "application/json",

                    clientId: gid,

                    clientSecret: getClientSecret(gid, cardAccountId),

                    "X-Trace-Id": traceId,

                    "X-Client-APP": buildClientHeader(),
                }),

                body: JSON.stringify(payload)

            })
                .then((response) => {

                    if (
                        response.status === 200 ||
                        response.status === 201 ||
                        response.status === 204
                    ) {
                        response.json().then(json => {
                            localStorage.setItem('emailID', json.emailId);
                            //  this.setState({ otpValidation: json.otpValidation });
                        })

                        toast.success(response.headers.get("message"), {
                            position: "top-right",
                            autoClose: 3000,
                        });

                    }
                    else if (response.status === 401) {

                        this.setState({
                            loader: false
                        });

                        if (this.props.history !== undefined) {
                            this.props.history.push('/sessionout')
                        }

                    }
                    else {

                        toast.error(response.headers.get("message"), {
                            position: "top-right",
                            autoClose: 3000,
                        });
                    }

                    this.setState({
                        loader: false
                    });

                    return response;
                });
        }
    };
    handleOtpSubmit = (otp, onSuccess, onError) => {

        this.setState({

            otp: otp,
            popupLoader: true,

        }, () => {

            this.handleSubmitQA(onSuccess, onError);

        });

    };
    handleSubmitCard() {



        if (this.state.expiryVerified === false && this.state.cardVerified === false) {
            this.setState({
                disabled: false,
                stepIndex: 1,
            })
        }
        else {
            this.setState({
                disabled: true,
                stepIndex: 0
            })
        }
        // this.setState({ stepIndex: 1 })
    }
    handleSubmitUserDetails() {



        if (this.state.dobVerified === false && this.state.mobileNumberVerified === false) {
            this.setState({
                disabledUserInfo: false,
                stepIndex: 2,
            })
        }
        else {
            this.setState({
                disabledUserInfo: true,
                stepIndex: 1,
            })
        }
        // this.setState({ stepIndex: 2 })
    }

    handleSubmitQA(onSuccess, onError) {
        let _this = this
        let state = {
            accountId: localStorage.getItem('cardAccountId'),
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
            secretPassword: this.state.secretPassword,
            secretQuestionCode: this.state.value,
            otp: this.state.otp
        }
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gsid = getClientId();
        let traceId = getClientId();
        fetch(plink + services.resetsq_qa, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gsid,
                'clientSecret': getClientSecret(gsid, localStorage.getItem('cardAccountId')),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    // this.setState({
                    //     loader: false
                    // })
                    if (onSuccess) {
                        onSuccess();
                    }

                    this.otpPopupCloseModal();

                    this.setState({
                        popupLoader: false,
                    });
                    setTimeout(function () { _this.props.history.push('/') }, 3000);
                }
                else if (response.status === 400) {
                    // eslint-disable-next-line
                    this.setState({
                        popupLoader: false,
                        loader: false
                    })
                    if (onError) {
                        onError(response.headers.get('message'));
                    }
                    toast.error('Please Login Again'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    }
                    // this.setState({
                    //     loader: false
                    // })

                }
                else if (response.status === 401) {

                    this.setState({
                        popupLoader: false,
                        loader: false
                    });

                    this.otpPopupCloseModal();

                    if (this.props.history !== undefined) {
                        this.props.history.push('/sessionout')
                    }

                }
                else if (response.status === 422) {

                    this.setState({
                        popupLoader: false,
                        loader: false,
                    });
                    if (onError) {
                        onError(response.headers.get('message'));
                    }
                    let message = response.headers.get("message");

                    response.json().then((json) => {
                        message = json.message
                            ? json.message
                            : response.headers.get("message");

                        toast.error(message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60,
                        });
                    });

                    // toast.error(message, {
                    //     position: "top-right",
                    //     autoClose: 3000,
                    //     hideProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     draggablePercent: 60,
                    // });

                }

                else {
                    // this.setState({
                    //     loader: false
                    // })
                    this.setState({
                        popupLoader: false,
                        loader: false
                    })
                    if (onError) {
                        onError(response.headers.get('message'));
                    }
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });

                }
            })
    }


    handleBirthDate = (dateOfBirth, date) => {
        let _this = this
        var month3;
        var date3;
        let year = new Date(date).getFullYear()
        let month = new Date(date).getMonth() + 1
        if (month > 0 && month < 10) {
            month3 = "0" + month
        }
        else {
            month3 = month
        }
        let date1 = new Date(date).getDate()
        if (date1 > 0 && date1 < 10) {
            date3 = "0" + date1
        }
        else {
            date3 = date1
        }
        let finalDate = year + "-" + month3 + "-" + date3

        this.setState({
            dobVerified: true,
            dobRederFeedback: false,
        })
        this.setState({
            dateOfBirth: finalDate

        }, () => {

            if (_this.state.dateOfBirth.length !== 0) {
                let state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    cardNumber: this.state.cardNumber,
                    dateOfBirth: _this.state.dateOfBirth
                }
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let gbid = getClientId();
                let traceId = getClientId();
                fetch(plink + services.resetsq_dob_verify, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': gbid,
                        'clientSecret': getClientSecret(gbid, this.state.actualCardNumber),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader(),

                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {

                            response.json().then(function (object) {

                                _this.setState({
                                    dobVerified: false,
                                    dobRederFeedback: true,
                                    dobverification: true,
                                }, () => {
                                    if (object.dateOfBirthVerified === true && object.mobileNumberVerified === false) {
                                        _this.setState({
                                            disabledUserInfo: false
                                        })
                                    }
                                    else {
                                        _this.setState({
                                            disabledUserInfo: true
                                        })
                                    }
                                })


                            })

                        } else {
                            _this.setState({
                                dobVerified: false,
                                dobRederFeedback: true,
                                dobverification: false,
                                disabledUserInfo: true
                                // mobiledisable: true,
                                // title: "Please enter valid card number"
                            })
                            // eslint-disable-next-line
                            toast.error(response.headers.get('message')), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,
                            };

                        }
                    })
            }
            else {
                if (_this.state.dateOfBirth.length !== 0)
                    // eslint-disable-next-line
                    toast.error(('please enter valid date of birth'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        disabledUserInfo: true,
                    });
            }
        })

    }
    formatDate = (date) => {
        let finalDate;
        let finalMonth;

        let getDate1 = date.getDate()
        if (getDate1 > 0 && getDate1 < 10) {
            finalDate = "0" + getDate1
        }
        else {
            finalDate = getDate1
        }

        let getMonth1 = date.getMonth() + 1

        if (getMonth1 > 0 && getMonth1 < 10) {
            finalMonth = "0" + getMonth1
        }
        else {
            finalMonth = getMonth1
        }



        return finalDate + "/" + finalMonth + "/" + date.getFullYear();
    }


    handelvalidateusername = (e, value) => {
        if (e.target.name === "userName") {
            if ((e.target.value.length) >= 6) {

                this.setState({
                    userName: value || this.state.userName,
                    correctUsername: true
                }, () => {
                    document.getElementById("valid1").style.display = "none"
                    document.getElementById("invalid1").style.display = "none"
                })
            } else {
                this.setState({
                    correctUsername: false
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            }, () => {


            })
        }
    }
    verifyCallback = response => {

        this.setState({
            response: response
        })
    }
    handleDate = (e, date) => {
        this.setState({
            secretPassword: this.converDate(date),
            dateSelected: true,
            // correctDob: true,
            secAnsSubmit: false
        })
    }
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }
    // formatDate = (date) => {
    //     return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    // }
    getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                const { cardVerified, rederFeedback, verification, expiryVerified, rederFeedback1, expiryVerification } = this.state;
                return (
                    <div className="col-sm-12" style={{ clear: "both", minHeight: "680px" }}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row" style={{ padding: "12px 25px", maxWidth: 800, minHeight: "100px", margin: 'auto', }} >
                                    <div>

                                        <div className="header-style" style={{ padding: "5px 15px 0px 11px" }}>
                                            <h4 className='logmainheading mainheading'>
                                                Resetting your Secret Q&A ?
                                            </h4>
                                            <p>Enter your card details to reset your Secret Q&A.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12" style={{ marginTop: "5px", clear: "both" }}>
                                <div className="row  mb-3" style={{ clear: "both", padding: "12px 15px", minHeight: "350px", maxWidth: 800, margin: 'auto', }} >
                                    <div className="summary-header ">
                                        <div className="row">
                                            {/* <div className="col-md-12">
                                                <p>Please Enter Your Card Number</p>
                                            </div> */}
                                            <div className=" col-md-12 ">
                                                <div className="col-md-6 ">
                                                    <div className="row input-group" >

                                                        <div className="col-sm-9">

                                                            <div className="group">
                                                                <InputMask mask="9999-9999-9999-9999" onChange={this.handlediable} placeholder="1234-1234-1234-1234"

                                                                    onBlur={this.checkCardNumber.bind(this)}
                                                                    defaultValue={this.state.actualCardNumber}
                                                                    name="cardNumber" id="cardNumber" ref="item" />
                                                                <span className="highlight"></span>
                                                                <span className="bar"></span>
                                                                <label>Enter Card Number</label>
                                                            </div>
                                                            {cardVerified ? <LoaderSmall /> : null}
                                                            {rederFeedback ? <div className="feedback" style={{ position: 'absolute', top: '10px', right: "3px" }}>
                                                                {verification ?
                                                                    <i className="fa fa-check" aria-hidden="true" style={{ color: "green", marginLeft: "3px" }}></i> :
                                                                    <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                            </div> : null}
                                                        </div>
                                                        {/* <div className="col-sm-2">
                                                            {cardVerified ? <LoaderSmall /> : null}
                                                            {rederFeedback ? <div className="feedback">
                                                                {verification ?
                                                                    <i className="fa fa-check" aria-hidden="true" style={{ color: "green", marginLeft: "3px" }}></i> :
                                                                    <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                            </div> : null}

                                                        </div> */}
                                                    </div>
                                                </div>

                                            </div>
                                            <div className=" col-md-12 nopaddingright">
                                                <div className=" col-md-6 nopaddingright">

                                                    <div className="row input-group">
                                                        <div className="col-sm-9">
                                                            <div className="group">
                                                                <InputMask mask="99/99"
                                                                    name="expiry"
                                                                    id="expiry"
                                                                    ref="item"
                                                                    // onChange={this.onChangeExpiry.bind(this)}
                                                                    placeholder="MM/YY"
                                                                    onBlur={this.handleExpiry.bind(this)}

                                                                    // disabled={this.state.exipryField}
                                                                    defaultValue={this.state.actualExpiryNumber}
                                                                />
                                                                <span className="highlight"></span>
                                                                <span className="bar"></span>
                                                                <label>Expiry Date</label>


                                                                {expiryVerified ? <LoaderSmall /> : null}
                                                                {rederFeedback1 ? <div className="feedback" style={{ position: "absolute", top: "10px", right: "10px" }}>
                                                                    {expiryVerification ?
                                                                        <i className="fa fa-check" aria-hidden="true" style={{ color: "green", marginLeft: "3px" }}></i> :
                                                                        <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                                </div> : null}

                                                            </div>

                                                        </div>
                                                        {/* <div className="col-sm-2">
                                                            {expiryVerified ? <LoaderSmall /> : null}
                                                            {rederFeedback1 ? <div className="feedback">
                                                                {expiryVerification ?
                                                                    <i className="fa fa-check" aria-hidden="true" style={{ color: "green", marginLeft: "3px" }}></i> :
                                                                    <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                            </div> : null}
                                                        </div> */}
                                                    </div>

                                                </div>
                                            </div>
                                            <div className=" col-md-12 nopaddingright">
                                                <div className="ml-4" style={{ marginTop: "10px" }}>
                                                    <RaisedButton
                                                        label="Go Back To HomePage"
                                                        // style={styles.button}
                                                        className="btn-std mt-2 mr-3"
                                                        backgroundColor="#FFCE39"
                                                        labelColor="#115876"
                                                        buttonStyle={{ borderRadius: 50 }}
                                                        style={{ borderRadius: 50 }}
                                                        onClick={this.handleGoback.bind(this)}
                                                    // icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                    />
                                                    <RaisedButton
                                                        label={'Next'}
                                                        disabled={this.state.disabled}
                                                        onClick={this.handleSubmitCard.bind(this)}
                                                        className="btn-std mt-2"
                                                        backgroundColor="#FFCE39"
                                                        labelColor="#115876"
                                                        buttonStyle={{ borderRadius: 50 }}
                                                        style={{ borderRadius: 50 }}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                );

            case 1:
                const { mobilecardVerified, mobileverification, mobilerederFeedback, dobVerified, dobRederFeedback, dobverification } = this.state
                return (
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row " style={{ padding: "12px 15px", maxWidth: 800, minHeight: "100px", margin: 'auto', }} >
                                <div>

                                    <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                        <h4 className='logmainheading mainheading'>
                                            Resetting your Secret Q&A ?
                                        </h4>
                                        <p>Enter your details to reset your Secret Q&A.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                            <div className="row  mb-3" style={{ padding: "12px 15px", minHeight: "300px", maxWidth: 800, margin: 'auto', }} >
                                <div className="col-md-6" style={{ marginTop: "20px" }}>
                                    <h5>Enter User Information</h5>
                                </div>
                                <div className="col-md-12 nopaddingright">
                                    <div className="col-md-6 nopaddingright">
                                        <div className="row input-group" >
                                            {/* <div className=" col-sm-1 group-icon">
                                                <i className="fa fa-mobile text-dark " aria-hidden="true" style={{ fontSize: "34px", right: "-7px" }}></i>
                                            </div> */}
                                            <div className="col-sm-11 ml-0 pl-0">
                                                <div className="group" style={{ marginTop: "0px", width: "100%" }}>
                                                    <TextField
                                                        hintText=""
                                                        id="mobileNumber"
                                                        floatingLabelText="Mobile Number"
                                                        name="mobileNumber"
                                                        type="number"
                                                        maxLength="20"
                                                        defaultValue={this.state.mobNum}
                                                        autoComplete="off"
                                                        //style={styles.customWidth}
                                                        style={{ width: '100%' }}
                                                        floatingLabelStyle={styles.floatingLabelStyle}
                                                        floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                                        underlineStyle={{ width: "180px" }}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        inputStyle={styles.inputStyle}
                                                        onBlur={this.handleMobileNumber.bind(this)}
                                                    />
                                                    {mobilecardVerified ? <LoaderSmall /> : null}
                                                    {mobilerederFeedback ? <div className="feedback" style={{ position: 'absolute', top: '10px', right: '10px' }}>
                                                        {mobileverification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green" }}></i> :
                                                            <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                    </div> : null}

                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                                <div className=" col-md-12 nopaddingright">
                                    <div className=" col-md-6 nopaddingright">


                                        <div className="row input-group">
                                            <div className=" col-sm-1 group-icon">
                                                <i className="fa fa-birthday-cake " aria-hidden="true" ></i>
                                            </div>
                                            <div className="col-sm-7" style={{ marginLeft: "3px", marginBottom: "18px" }}>
                                                <DatePicker
                                                    name="dateOfBirth"
                                                    openToYearSelection={true}
                                                    floatingLabelText="Date Of Birth"
                                                    className="input-width required"
                                                    id="dateofbirth"
                                                    // defaultDate={new Date()}
                                                    maxDate={new Date()}
                                                    defaultDate={(this.state.dateOfBirth) ? new Date(this.state.dateOfBirth) : this.state.dateOfBirth}
                                                    onChange={this.handleBirthDate}
                                                    formatDate={this.formatDate}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    disabled={this.state.DobDisabled}
                                                    underlineStyle={styles.underlineStyle}
                                                    floatingLabelStyle={styles.floatingLabelStyle}
                                                    textFieldStyle={{ width: "100%", fontSize: "16px" }}
                                                />
                                            </div>
                                            <div className="col-sm-2">
                                                {dobVerified ? <LoaderSmall /> : null}
                                                {dobRederFeedback ? <div style={{ position: "absolute", top: "37px" }}>
                                                    {dobverification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green" }}></i> :
                                                        <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                </div> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-10 nopaddingright">
                                    <div className="row">
                                        <div className=" col-sm-12" style={{ marginTop: "15px" }} >
                                            <RaisedButton
                                                label="back"
                                                onClick={this.handleback}
                                                style={styles.button}
                                                className="btn-std mt-2"
                                                backgroundColor="#FFCE39"
                                                labelColor="#115876"
                                                buttonStyle={{ borderRadius: 50 }}
                                            />

                                            <RaisedButton
                                                label={'Next'}
                                                disabled={this.state.disabledUserInfo}
                                                onClick={this.handleSubmitUserDetails.bind(this)}
                                                style={styles.button}
                                                className="btn-std mt-2 ml-2"
                                                backgroundColor="#FFCE39"
                                                labelColor="#115876"
                                                buttonStyle={{ borderRadius: 50 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div >
                );

            case 2:
                const { correctDob } = this.state
                const { secretQues } = this.props
                return (
                    <div className="row">
                        {this.state.otpOpen && (

                            <OtpPopup
                                open={this.state.otpOpen}
                                onClose={this.otpPopupCloseModal}
                                handleRequestOtp={this.handleRequestOtp}
                                onSubmit={this.handleOtpSubmit}
                                loading={this.state.popupLoader}
                            />
                        )}
                        <div className="col-md-12">
                            <div className="row " style={{ padding: "12px 15px", maxWidth: 800, minHeight: "100px", margin: 'auto', }} >
                                <div>

                                    <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                        <h4 className='logmainheading mainheading'>
                                            Resetting your Secret Q&A ?
                                        </h4>
                                        <p>Reset your Secret Q&A.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                            <div className="row  mb-3" style={{ padding: "12px 15px", minHeight: "300px", maxWidth: 800, margin: 'auto', }} >
                                {/* <div className="col-md-6" style={{ marginTop: "20px" }}>
                                    <h5>Enter Secret Q&A</h5>
                                </div> */}
                                <div className=" col-md-12 nopaddingright">
                                    <div className="col-md-10 nopaddingright">

                                        <div className="row input-group" >
                                            {/* <div className=" col-sm-1 group-icon" style={{ paddingLeft: "10px" }}>
                                                <i className="fa fa-question-circle" aria-hidden="true"></i>
                                            </div> */}
                                            <div className="col-sm-8" >
                                                <SelectField
                                                    value={this.state.value}
                                                    onChange={this.handleSelect}
                                                    name="secretQuestionCode"

                                                    floatingLabelText="Secret Question"
                                                    className="input-width required"
                                                >
                                                    {(secretQues.message === "Success") ? secretQues.body.map((value, i) =>
                                                        <MenuItem className="menuitem" value={secretQues.body[i].secretQuestionCode} primaryText={secretQues.body[i].description} key={i} />
                                                    ) : <div>Select Question</div>}
                                                </SelectField>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className=" col-md-12 nopaddingright">
                                    <div className="col-md-10 nopaddingright">

                                        <div className="row input-group" >
                                            {/* <div className=" col-sm-1 group-icon" style={{ paddingLeft: "10px" }} >
                                                <img style={{ bottom: "-36px", position: "relative" }} src={answerimg} alt="" />
                                            </div> */}
                                            <div className="col-sm-8">
                                                {/* <TextField
                                            hintText={(this.state.value === "DOB") ? "DD/MM/YYYY" : "Start Typing.."}
                                            floatingLabelText="Secret Answer"
                                            type="text"
                                            title={(this.state.secAnsDisabled === true) ? 'Please select secret question' : 'Type secret answer'}
                                            name="secretAnswer"
                                            maxLength="50"
                                            className="input-width required"
                                            onChange={this.onChange}
                                            disabled={this.state.secAnsDisabled}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                            errorText={correctDob ? null : "Enter correct format"}
                                        /> */}
                                                {(this.state.value === "DOB") ?

                                                    <DatePicker hintText="Birthday"
                                                        // container="inline" mode="landscape"
                                                        openToYearSelection={true}
                                                        floatingLabelText="Secret Answer(Date Of Birth)"
                                                        style={{ width: "100%" }}
                                                        type="text"
                                                        name="secretAnswer"
                                                        onChange={this.handleDate}
                                                        maxDate={new Date()}
                                                        formatDate={this.formatDate}
                                                        className="input-width required"
                                                        // defaultValue={this.state.secretAnswerDate || null}
                                                        // defaultDate={( new Date(this.state.secretAnswerDate))} 
                                                        // defaultDate={ this.state.secretAnswerDate}
                                                        defaultDate={(this.state.secretAnswerDate) ? new Date(this.state.secretAnswerDate) : this.state.secretAnswerDate}

                                                        // defaultDate={new Date()}
                                                        // defaultDate= {new Date()}
                                                        floatingLabelStyle={styles.floatingLabelStyle1}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle} />
                                                    :
                                                    <TextField
                                                        hintText={(this.state.value === "DOB") ? "DD/MM/YYYY" : "Start Typing.."}
                                                        floatingLabelText="Secret Answer"
                                                        type="text"
                                                        name="secretAnswer"
                                                        autoComplete='off'
                                                        maxLength="50"
                                                        className="input-width required"
                                                        onChange={this.onChange}
                                                        // onBlur={this.onBlurSecAns}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        errorText={correctDob ? null : "Enter correct format"}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-10 nopaddingright">
                                    <div className="row">
                                        <div className=" col-sm-12" style={{ marginTop: "15px" }} >
                                            <RaisedButton
                                                label="back"
                                                onClick={this.handlebackStep1}
                                                style={styles.button}
                                                className="btn-std mt-2 ml-3"
                                                backgroundColor="#333"
                                                labelColor="#115876"
                                                buttonStyle={{ borderRadius: 50 }}
                                            // style={{ borderRadius: 50 }}                                                  
                                            />
                                            <RaisedButton
                                                label={'Submit'}
                                                disabled={this.state.secAnsSubmit}
                                                // onClick={this.handleSubmitQA.bind(this)}
                                                onClick={this.otpPopupOpenModal}
                                                style={styles.button}
                                                className="btn-std mt-2 ml-2"
                                                backgroundColor="#FFCE39"
                                                labelColor="#115876"
                                                buttonStyle={{ borderRadius: 50 }}
                                            // style={{ borderRadius: 50 }}                                                  
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                );
            default:
                return (
                    <div>Something Went Wrong</div>
                )
        }

    }
    handleActivate() {
        const { publicKey } = this.props
        const { expiry, pin, confirmPin } = this.state;
        let userInfo1 = localStorage.getItem('updateSecurityInfo')
        let statusInfo1 = localStorage.getItem('status')
        let expiryDate = expiry.replace("/", "");
        if (expiry === "") {
            this.setState({ expiryError: true })
        } else {
            this.setState({ expiryError: false })
        }
        if (pin === "") {
            this.setState({ pinError: true })
        } else {
            this.setState({ pinError: false })
        }
        if (confirmPin === "") {
            this.setState({ confirmPinError: true })
        } else {
            this.setState({ confirmPinError: false })
        }
        // this.setState({ stepIndex: 1 })
        let _this = this
        if (pin !== "" && confirmPin !== "" && expiry !== "") {
            if (pin.length === 4) {
                if (confirmPin.length === 4) {
                    if (pin === confirmPin) {
                        if (publicKey && publicKey.status === 200) {
                            const public_Key = publicKey.body.publickey;
                            let encrypt = new JSEncrypt();
                            encrypt.setPublicKey(public_Key);
                            const state = {
                                expDate: encrypt.encrypt(expiryDate),
                                cardNumber: localStorage.getItem("cardNumber"),
                                pin: encrypt.encrypt(this.state.pin),
                                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                                updateSecurityInfo: userInfo1
                            }
                            this.setState({
                                loader: true
                            })
                            if (statusInfo1 === "A" && userInfo1 === "Y") {
                                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                                let traceId = getClientId();
                                fetch(plink + services.activate_card, {
                                    method: 'POST',
                                    headers: new Headers({
                                        'Content-Type': 'application/json',
                                        'X-Trace-Id': traceId,
                                        'X-Client-APP': buildClientHeader(),
                                    }),
                                    body: JSON.stringify(state)
                                })
                                    .then(response => {
                                        if (response.status === 200 || response.status === 201) {

                                            toast.success(response.headers.get('message'), {
                                                position: "top-right",
                                                draggablePercent: 60,
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: false
                                            });
                                            this.setState({
                                                loader: false
                                            })

                                            response.json().then(function (object) {
                                                _this.setState({
                                                    activatedCardNumber: object.cardNumber,
                                                    activatedExpDate: object.expDate,
                                                    activatedFirstName: object.firstName,
                                                    activatedLastName: object.lastName
                                                })

                                                localStorage.setItem("accountId", object.accountId)

                                                _this.setState({ stepIndex: 1 })

                                            })

                                        } else {
                                            this.setState({
                                                loader: false
                                            })
                                            toast.error(response.headers.get('message'), {
                                                position: "top-right",
                                                autoClose: 5000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true
                                            });
                                        }
                                    })

                            }

                            else {
                                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                                let traceId = getClientId();
                                fetch(plink + services.activate_card, {
                                    method: 'POST',
                                    headers: new Headers({
                                        'Content-Type': 'application/json',
                                        'X-Trace-Id': traceId,
                                        'X-Client-APP': buildClientHeader(),
                                    }),
                                    body: JSON.stringify(state)
                                })
                                    .then(response => {
                                        if (response.status === 200 || response.status === 201) {


                                            this.setState({
                                                loader: false
                                            })

                                            response.json().then(function (json) {
                                                let exp = json.expiryInMinutes

                                                let expiry = (exp * 60000 + new Date().getTime())

                                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                                localStorage.setItem("loginState", true)
                                                localStorage.setItem('memberId', json.memberId);
                                                localStorage.setItem('token', json.token)
                                                localStorage.setItem('accountId', json.accountId);

                                                localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                                localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                                toast.success(response.headers.get('message'), {
                                                    position: "top-right",
                                                    draggablePercent: 60,
                                                    autoClose: 3000,
                                                    hideProgressBar: false,
                                                    closeOnClick: true,
                                                    pauseOnHover: true,
                                                    draggable: false
                                                });
                                                setTimeout(function () {
                                                    _this.props.history.push("/home")
                                                }, 3000)



                                            })

                                        } else {
                                            this.setState({
                                                loader: false
                                            })
                                            toast.error(response.headers.get('message'), {
                                                position: "top-right",
                                                autoClose: 5000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true
                                            });
                                        }
                                    })

                            }






                        }
                    } else {
                        this.setState({
                            loader: false
                        })
                        toast.error("Enter and Confirm Pin Doesn't Match !", {
                            position: "top-right",
                            autoClose: true,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true
                        });
                    }
                } else {
                    this.setState({
                        loader: false
                    })
                    // eslint-disable-next-line
                    toast.error('Confirm PIN should be 4 digits'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };

                }
            } else {
                // eslint-disable-next-line
                toast.error('New PIN should be 4 digits .'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                };

            }

        }


    }
    handleback = () => {
        this.props.history.push(this.setState({
            rederFeedback: false,
            rederFeedback1: false,
            stepIndex: 0,
            disabled: false,
            exipryField: true,

        }))
    }
    handlebackStep1 = () => {
        this.props.history.push(this.setState({
            mobilerederFeedback: false,
            dobRederFeedback: false,
            DobDisabled: true,
            disabledUserInfo: false,
            stepIndex: 1
        }))
    }
    handelepassword = (e, value) => {
        // eslint-disable-next-line
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "password") {
            if (passwd.test(e.target.value)) {
                this.setState({
                    correctPassword: true,
                    password: value
                })
            } else {
                this.setState({
                    correctPassword: false
                })
            }
        }

    }
    handleVerify() {
        const { response } = this.state
        const { publicKey } = this.props
        let _this = this;

        if (response !== "") {
            if (publicKey && publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    secretQuestionCode: encrypt.encrypt(this.state.value),
                    accountId: encrypt.encrypt(localStorage.getItem("accountId")),
                    secretPassword: encrypt.encrypt(this.state.secretPassword),
                    userName: encrypt.encrypt(this.state.userName),
                    password: encrypt.encrypt(this.state.password),
                    emailId: encrypt.encrypt(this.state.email)
                }
                this.setState({
                    loader: false
                })
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let gid = getClientId();
                let traceId = getClientId();
                fetch(plink + services.update_user_info + "/?g-recaptcha-response=" + response, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': gid,
                        'clientSecret': getClientSecret(gid, this.state.emailId),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader(),
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            this.setState({
                                loader: false
                            })
                            response.json().then(function (object) {
                                let exp = object.expiryInMinutes

                                let expiry = (exp * 60000 + new Date().getTime())

                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                localStorage.setItem("loginState", true)
                                localStorage.setItem('memberId', object.memberId);
                                localStorage.setItem('token', object.token)
                                localStorage.setItem('accountId', object.accountId);

                                localStorage.setItem('lastSuccessfulLogin', object.lastSuccessfulLogin);
                                localStorage.setItem('lastUnsuccessfulLogin', object.lastUnsuccessfulLogin);
                                localStorage.setItem('shlimit', object.cardholderKYCLevel);
                                localStorage.setItem('kycintegration', object.kycIntegration)

                                _this.props.history.push("/home")

                            })
                        } else {
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                        }
                    })

            }
        }
    }

    handleUserInfo() {
        const { correctPassword } = this.state

        const { value, secretPassword, userName, password, email, confirmPassword } = this.state

        if (password !== "" && confirmPassword !== "" && email !== "" && userName !== "" && secretPassword !== "" && value !== "") {
            if (correctPassword === false) {
                this.setState({
                    correctPassword: false,
                })
            }
            else {
                if (password === confirmPassword) {
                    // eslint-disable-next-line
                    if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(email)) {
                        this.setState({ stepIndex: 2 })
                    } else {
                        // eslint-disable-next-line
                        toast.error('Not a valid email'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        }

                    }
                } else {
                    // eslint-disable-next-line
                    toast.error('New Password and Confirm Password should be same'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    }

                }
            }
        }
        else {

        }
    }

    handleActiveUser() {
        const { publicKey } = this.props
        const { expiry, pin, confirmPin } = this.state;
        let expiryDate = expiry.replace("/", "");
        if (expiry === "") {
            this.setState({ expiryError: true })
        } else {
            this.setState({ expiryError: false })
        }
        if (pin === "") {
            this.setState({ pinError: true })
        } else {
            this.setState({ pinError: false })
        }
        if (confirmPin === "") {
            this.setState({ confirmPinError: true })
        } else {
            this.setState({ confirmPinError: false })
        }
        // this.setState({ stepIndex: 1 })
        let _this = this
        if (pin !== "" && confirmPin !== "" && expiry !== "") {
            if (pin === confirmPin) {
                if (publicKey && publicKey.status === 200) {
                    const public_Key = publicKey.body.publickey;
                    let encrypt = new JSEncrypt();
                    encrypt.setPublicKey(public_Key);
                    const state = {
                        expDate: encrypt.encrypt(expiryDate),
                        cardNumber: localStorage.getItem("cardNumber"),
                        pin: encrypt.encrypt(this.state.pin),
                        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                        updateSecurityInfo: "Y"
                    }
                    this.setState({
                        loader: true
                    })
                    let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                    let traceId = getClientId();
                    fetch(plink + services.activate_card, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'X-Trace-Id': traceId,
                            'X-Client-APP': buildClientHeader(),
                        }),
                        body: JSON.stringify(state)
                    })
                        .then(response => {
                            if (response.status === 200 || response.status === 201) {
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });
                                this.setState({
                                    loader: false
                                })

                                response.json().then(function (object) {
                                    _this.setState({
                                        activatedCardNumber: object.cardNumber,
                                        activatedExpDate: object.expDate,
                                        activatedFirstName: object.firstName,
                                        activatedLastName: object.lastName
                                    })
                                    localStorage.setItem("accountId", object.accountId)
                                    // _this.setState({ stepIndex: 1 })
                                })
                            } else {
                                this.setState({
                                    loader: false
                                })
                                toast.error(response.headers.get('message'), {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true
                                });
                            }
                        })
                }
            } else {
                this.setState({
                    loader: false
                })
                toast.error("Enter and Confirm Pin Doesn't Match !", {
                    position: "top-right",
                    autoClose: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            }

        }

    }
    render() {
        const { stepIndex } = this.state;


        const height = $(window).height() - 200;


        return (
            <div style={{ overflow: "hidden", minHeight: '710px' }} >
                <div><DefaulNavbar /> </div>
                <div style={{ height: height }}>
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable
                        pauseOnHover
                        style={{ zIndex: 999999 }}
                    />
                    <div style={{ width: '100%', maxWidth: 800, margin: 'auto', }}>
                        <Stepper activeStep={stepIndex} >
                            <Step className="step">
                                <StepLabel>Card Details</StepLabel>
                            </Step>
                            <Step className="step">
                                <StepLabel>User Information</StepLabel>
                            </Step>
                            <Step className="step">
                                <StepLabel>Reset Secret Q&A</StepLabel>
                            </Step>
                        </Stepper>
                    </div>
                    {this.getStepContent(stepIndex)}


                    {this.state.loader === true &&
                        <div className="col-sm-1" style={{ marginTop: "-61px", marginLeft: "90px", width: "30% !mportant" }} >
                            <LoaderSmall />
                        </div>}
                    {/* {stepIndex === 2 &&
                    <div style={{ marginTop: "-49px", marginLeft: "135px" }}>
                        <RaisedButton
                            label="back"
                            onClick={this.handleback}
                            style={styles.button}
                            backgroundColor="#333"
                            labelColor="#fff"
                        />
                    </div>} */}


                    {/* Same as */}
                    {/* <div className="col-sm-12 modal-for-login flowmodal" id="myModal" style={{ display: "none" }}>
                    <div className="modal-content col-sm-4" style={{ background: "rgb(214, 70, 84)" }}>
                        <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                            <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                                <div className="row">
                                    <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                        <span>Error</span>
                                    </div>
                                    <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                        <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose.bind(this)} aria-label="Close">
                                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                            <div className="col-sm-12" >
                                <i className="fa fa-times fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                            </div>
                            <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                <span>User Id already exists!</span>
                            </div>
                            <div className="col-sm-12" >
                                <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)" }}
                                    onClick={this.handleClose.bind(this)}
                                    aria-label="Close">
                                    OK
                           </button>
                            </div>
                        </div>
                    </div>
                </div> */}
                </div>
            </div>
        );
    }
}


ResetQuestion.propTypes = {
    keyRecieved: PropTypes.bool
};
ResetQuestion.defaultProps = {
    keyRecieved: false
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetQuestion));


// WEBPACK FOOTER //
// ./src/components/resetsecretq/resetquestion.jsx